import {
  Avatar,
  Button,
  Link,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material'
import { FC, useMemo } from 'react'

import { UserTradeBoxFragment } from '@/clients/utoniq-core/schema'
import { useRouter, useTranslation } from '@/core'

type UserTradeBoxProps = {
  userTrade: UserTradeBoxFragment
  itemId: string
}

export const UserTradeBox: FC<UserTradeBoxProps> = ({ itemId, userTrade }) => {
  const { generatePath, routerPages } = useRouter()
  const { t } = useTranslation('tradeRequestUserSelect')

  const serialsLength = useMemo(
    () => userTrade.serials.filter(o => !o.isProtected).length,
    [userTrade.serials]
  )

  if (!serialsLength) {
    return null
  }

  return (
    <ListItem
      divider
      sx={{ py: 4 }}
      disablePadding
      secondaryAction={
        <Button
          href={generatePath(routerPages.SerialNumberSelect, {
            itemId: itemId,
            userId: userTrade.user.id,
          })}
        >
          {t('choice')}
        </Button>
      }
      disableGutters={true}
    >
      <Link
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 'fit-content',
        }}
        href={generatePath(routerPages.UserProfile, {
          userId: userTrade.user?.id ?? '#',
        })}
      >
        <ListItemAvatar sx={{ mr: 2, minWidth: 'auto' }}>
          <Avatar
            src={userTrade.user?.avatar?.smallUri ?? ''}
            sx={{ width: 36, height: 36 }}
          />
        </ListItemAvatar>
        <ListItemText
          sx={{ flex: '0 0 auto', mr: 2 }}
          primary={userTrade.user.displayName}
          slotProps={{
            primary: {
              variant: 'subtitle1',
              color: 'text.secondary',
            },
          }}
        />
      </Link>
      <ListItemText
        primary={t('numberOfPossessions', { number: serialsLength })}
        slotProps={{
          primary: {
            variant: 'overline',
            color: 'text.hint',
          },
        }}
      />
    </ListItem>
  )
}
